module.exports = __webpack_public_path__ + "img/DE00307.aa1a1cf4.png";